import React from "react";
import "../../../css/DesignSystem/Filters/FilterDrawer.css";
import { ReactComponent as CloseIcon } from "../../../assets/icons/close.svg";

const joinClassNames = (...classNames) => classNames.filter(Boolean).join(" ");

const FilterDrawer = ({
  open,
  title = "Filters",
  children,
  footer,
  onClose,
  closeLabel = "Close filters",
  className = "",
}) => {
  if (!open) return null;

  return (
    <div className="FilterDrawerOverlay">
      <aside className={joinClassNames("FilterDrawer", className)}>
        <div className="FilterDrawer__Header">
          <div className="FilterDrawer__Title">{title}</div>

          <button
            type="button"
            className="FilterDrawer__Close"
            onClick={onClose}
            aria-label={closeLabel}
          >
            <CloseIcon />
          </button>
        </div>

        <div className="FilterDrawer__Body">{children}</div>

        {footer ? <div className="FilterDrawer__Footer">{footer}</div> : null}
      </aside>
    </div>
  );
};

export const FilterDrawerSection = ({ title, children, className = "" }) => {
  return (
    <div className={joinClassNames("FilterDrawer__Section", className)}>
      <div className="FilterDrawer__SectionTitle">{title}</div>
      {children}
    </div>
  );
};

export const FilterDrawerCheckboxOption = ({ label, checked, onChange }) => {
  return (
    <label className="FilterDrawer__Checkbox">
      <input type="checkbox" checked={checked} onChange={onChange} />
      <span>{label}</span>
    </label>
  );
};

export const FilterDrawerPills = ({ children, className = "" }) => {
  return (
    <div className={joinClassNames("FilterDrawer__Pills", className)}>
      {children}
    </div>
  );
};

export const FilterDrawerPill = ({
  active,
  children,
  onClick,
  className = "",
}) => {
  return (
    <button
      type="button"
      className={joinClassNames(
        "FilterDrawer__Pill",
        active && "FilterDrawer__Pill--Active",
        className
      )}
      onClick={onClick}
    >
      {children}
    </button>
  );
};

export const FilterDrawerEmpty = ({ children }) => {
  return <div className="FilterDrawer__Empty">{children}</div>;
};

export const FilterDrawerApplyButton = ({ children, onClick }) => {
  return (
    <button type="button" className="FilterDrawer__Apply" onClick={onClick}>
      {children}
    </button>
  );
};

export const FilterDrawerResetButton = ({ children, onClick }) => {
  return (
    <button type="button" className="FilterDrawer__Reset" onClick={onClick}>
      {children}
    </button>
  );
};

export default FilterDrawer;
